import { SagaIterator } from 'redux-saga';
import { all, put, call, takeLatest } from 'redux-saga/effects';
import { MCAFirebaseSaga } from '../root-saga';
import {
  GET_USERS,
  GET_USERS_ORDERS,
  AdminProps,
  FirestoreSnapshot,
  // OrderState,
  GetOrderAction,
  DeletePhotoAction,
  DELETE_PHOTO,
  GetCookMealsAction,
  GET_COOKMEALS,
  GET_ADVERTISEMENT,
  ADD_ADVERTISEMENT,
  UploadAds,
  DeleteAdsAction,
  DELETE_ADS,
} from './types';

import { setLoading, setError } from '../app-globals/actions';
import { setAllUsers, setAllOrders, setCookMeals, setAds } from './actions';
import { firestore } from '../../constants/firebase';
import 'firebase/auth';
import _ from 'lodash';
import firebase from 'firebase';

function* fetAllUsers(): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Fetching Users'));
    const userSnapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      'users'
    );
    const users: AdminProps[] = [];

    userSnapshot.forEach((items: FirestoreSnapshot) => {
      if (items.data().accountType !== 'admin') {
        const body = {
          key: items.id,
          ...items.data(),
          name: `${items.data().firstName} ${items.data().lastName}`,
          status: [`${items.data().status}`],
        };
        users.push(body);
      }
    });
    yield put(setAllUsers(users));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, 'Error while fetching users'));
  }
}

function* fetUserOrders({
  key,
  accountType,
}: GetOrderAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Fetching orders'));
    const ordersCookRef = firestore
      .collection('orders')
      .where('cook', '==', key);
    const ordersGuestRef = firestore
      .collection('orders')
      .where('guest', '==', key);
    const ordersSnapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      accountType === 'i seek' ? ordersGuestRef : ordersCookRef
    );
    const mealSnapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      'meals'
    );
    const orders: AdminProps[] = [];

    ordersSnapshot.forEach((items: FirestoreSnapshot) => {
      mealSnapshot.forEach((mealitems: FirestoreSnapshot) => {
        if (items.data().mealid === mealitems.id) {
          const body = {
            id: items.id,
            title: mealitems.data().title,
            description: mealitems.data().description,
            status: items.data().status,
            consumptiondate: items.data().consumptiondate,
            ...mealitems.data(),
          };
          orders.push(body);
        }
      });
    });
    yield put(setAllOrders(orders));
    // console.log('wew', orders);
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, 'Error while fetching orders'));
  }
}

function* handleDelete({
  key,
  deletetype,
}: DeletePhotoAction): SagaIterator<void> {
  try {
    yield put(
      setLoading(
        true,
        `${
          deletetype === 'suspended'
            ? 'suspending user...'
            : deletetype === 'activated'
            ? 'activating user...'
            : 'deleting user...'
        }`
      )
    );
    let isSuccess = false;
    if (deletetype === 'photo') {
      const body = {
        image: '',
      };
      yield call(MCAFirebaseSaga.firestore.setDocument, `users/${key}`, body, {
        merge: true,
      });
      yield put(setLoading(false, ''));
      window.location.replace('/admin');
    } else if (deletetype === 'suspended' || deletetype === 'activated') {
      const body = {
        status: deletetype === 'suspended' ? 'suspended' : 'active',
      };
      yield call(MCAFirebaseSaga.firestore.setDocument, `users/${key}`, body, {
        merge: true,
      });
      yield put(setLoading(false, ''));
      window.location.replace('/admin');
    } else {
      yield call(MCAFirebaseSaga.firestore.deleteDocument, `users/${key}`);
      const res = firebase.functions().httpsCallable('userDeletions')({
        userid: key,
      });
      const prom = () => {
        return res
          .then(data => {
            console.log('call function', data);
            isSuccess = true;
            return isSuccess;
          })
          .catch(err => {
            isSuccess = false;
            return false;
          });
      };
      const mess = yield call(prom);
      if (mess) {
        yield put(setLoading(false, ''));
        window.location.replace('/admin');
        return;
      }
      yield put(setLoading(false, ''));
      yield put(setError(true, 'error deleting user'));
    }
  } catch (e) {
    yield put(setLoading(false, `Error deleting photo`));
  }
}

function* fetchCookMeals({ cookid }: GetCookMealsAction): SagaIterator<void> {
  try {
    // const { user } = yield select(getUserState);
    yield put(setLoading(true, 'Fetching Meals'));

    const mealRef = firestore.collection('meals').where('cook', '==', cookid);

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      mealRef
    );
    const meal: AdminProps[] = [];
    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        id: item.id,
        ...item.data(),
      };
      meal.push(body);
    });
    yield put(setCookMeals(_.orderBy(meal, ['timeadded'], 'desc')));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* UploadAdvertisement({ banner }: UploadAds): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Uploading Ads'));
    const generateImgName = Math.random()
      .toString(36)
      .substring(2);
    const imageFilename = 'ADS_' + generateImgName.toUpperCase() + Date.now();

    const task = yield call(
      MCAFirebaseSaga.storage.uploadString,
      imageFilename,
      banner.image,
      'data_url',
      { contentType: 'image/jpeg' }
    );

    yield task; // Wait for upload to complete
    const imageUrl = yield call(
      MCAFirebaseSaga.storage.getDownloadURL,
      imageFilename
    );
    const body = {
      image: imageUrl,
      name: banner.name,
      siteUrl: banner.siteUrl,
      position: banner.position,
    };
    const addAds = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'advertisement',
      body
    );
    console.log(addAds);
    yield put(setLoading(false, 'Ads Added Successfully'));
    window.location.replace('/advertisement');
  } catch (error) {
    console.log(error);
    yield put(setLoading(false, ''));
    yield put(setError(true, error.message));
  }
}

function* DeleteAds({ id }: DeleteAdsAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'deleting Ads'));
    yield call(MCAFirebaseSaga.firestore.deleteDocument, `advertisement/${id}`);
    yield put(setLoading(false, ''));
    window.location.replace('/advertisement');
  } catch (error) {
    yield put(setLoading(false, ''));
    yield put(setError(true, error.message));
    console.log(error);
  }
}

function* GetAdvertisement(): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Fetching Ads'));
    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      'advertisement'
    );
    const advertisement: AdminProps[] = [];
    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        id: item.id,
        ...item.data(),
      };
      advertisement.push(body);
    });
    yield put(setAds(advertisement));
    yield put(setLoading(false, ''));
  } catch (error) {
    yield put(setLoading(false, ''));
  }
}

export function* AdminSaga(): SagaIterator {
  yield all([
    takeLatest(GET_USERS, fetAllUsers),
    takeLatest(GET_USERS_ORDERS, fetUserOrders),
    takeLatest(DELETE_PHOTO, handleDelete),
    takeLatest(GET_COOKMEALS, fetchCookMeals),
    takeLatest(ADD_ADVERTISEMENT, UploadAdvertisement),
    takeLatest(GET_ADVERTISEMENT, GetAdvertisement),
    takeLatest(DELETE_ADS, DeleteAds),
  ]);
}
